var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCompassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Button New/Default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button Base"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    fill: "#E2F7F5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "#E2F7F5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon-new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Application/Compass",
    clipPath: "url(#clip0_201_43594)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22 14C17.5821 14 14 17.5821 14 22C14 26.4179 17.5821 30 22 30C26.4179 30 30 26.4179 30 22C30 17.5821 26.4179 14 22 14ZM22 28.6429C18.3321 28.6429 15.3571 25.6679 15.3571 22C15.3571 18.3321 18.3321 15.3571 22 15.3571C25.6679 15.3571 28.6429 18.3321 28.6429 22C28.6429 25.6679 25.6679 28.6429 22 28.6429ZM25.5429 18.1411C25.4729 18.1137 25.3983 18.1005 25.3232 18.102C25.2481 18.1035 25.1741 18.1198 25.1054 18.15L20.2661 20.2679L18.15 25.1071C18.0857 25.2536 18.0857 25.4196 18.15 25.5661C18.2107 25.7054 18.3232 25.8143 18.4661 25.8696C18.5339 25.8964 18.6036 25.9089 18.675 25.9089C18.7536 25.9089 18.8304 25.8929 18.9036 25.8607L23.7429 23.7429L25.8589 18.9036C25.8898 18.8329 25.9061 18.7568 25.9068 18.6797C25.9076 18.6027 25.8927 18.5262 25.8632 18.455C25.8337 18.3838 25.7901 18.3193 25.7351 18.2654C25.68 18.2114 25.6146 18.1691 25.5429 18.1411ZM23.1571 22.4L23.625 22.8679L22.8679 23.625L22.4 23.1571L19.6429 24.3643L20.8482 21.6071L20.3929 21.15L21.15 20.3929L21.6054 20.8482L24.3643 19.6429L23.1571 22.4ZM21.15 20.3929L20.3929 21.15L20.8482 21.6071L22.4 23.1571L22.8679 23.625L23.625 22.8679L23.1571 22.4L21.6071 20.8482L21.15 20.3929Z",
    fill: "#007672"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_43594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompassIcon);
export default __webpack_public_path__ + "static/media/compass-icon.ee5ccdb9d1e4c9ba928296e16f1c5ed8.svg";
export { ForwardRef as ReactComponent };